import React from 'react';

const ErrorList = ({ errors, labels }) => (
  <div className="p-2 text-sm bg-red-200 text-red-600">
    <ul>
      {Object.entries(errors).map(([name, errors]) => {
        return (
          <li key={name}>
            <span className="font-semibold">{labels[name]}</span>:{' '}
            {errors.map((errorMessage, idx) => (
              <span key={idx}>
                {errorMessage}
                {idx === errors.length - 1 ? '' : ', '}
              </span>
            ))}
          </li>
        );
      })}
    </ul>
  </div>
);

export default ErrorList;
